const IS_WITHIN_SUBPATTERNS = {
  PAST_WEEK: { pattern: 'past_week', requiresFilterValue: false },
  PAST_MONTH: { pattern: 'past_month', requiresFilterValue: false },
  PAST_YEAR: { pattern: 'past_year', requiresFilterValue: false },
  NEXT_WEEK: { pattern: 'next_week', requiresFilterValue: false },
  NEXT_MONTH: { pattern: 'next_month', requiresFilterValue: false },
  NEXT_YEAR: { pattern: 'next_year', requiresFilterValue: false },
  NEXT_NUMBER_OF_DAYS: {
    pattern: 'next_number_of_days',
    requiresFilterValue: true,
  },
  PAST_NUMBER_OF_DAYS: {
    pattern: 'past_number_of_days',
    requiresFilterValue: true,
  },
};

const DATE_SUBPATTERNS = {
  EXACT_DATE: { pattern: 'exact_date', requiresFilterValue: true },
  TODAY: { pattern: 'today', requiresFilterValue: false },
  TOMORROW: { pattern: 'tomorrow', requiresFilterValue: false },
  YESTERDAY: { pattern: 'yesterday', requiresFilterValue: false },
  ONE_WEEK_AGO: { pattern: 'one_week_ago', requiresFilterValue: false },
  ONE_WEEK_FROM_NOW: {
    pattern: 'one_week_from_now',
    requiresFilterValue: false,
  },
  ONE_MONTH_AGO: { pattern: 'one_month_ago', requiresFilterValue: false },
  ONE_MONTH_FROM_NOW: {
    pattern: 'one_month_from_now',
    requiresFilterValue: false,
  },
  NUMBER_OF_DAYS_FROM_NOW: {
    pattern: 'number_of_days_from_now',
    requiresFilterValue: true,
  },
};

const HAS_FILE_TYPE_SUBPATTERNS = {
  IMAGE: { pattern: 'image', requiresFilterValue: false },
  TEXT: { pattern: 'text', requiresFilterValue: false },
};

module.exports = {
  CONTAINS: {
    pattern: 'contains',
    requiresFilterValue: true,
  },
  DOES_NOT_CONTAIN: {
    pattern: 'does_not_contain',
    requiresFilterValue: true,
  },
  IS: {
    pattern: 'is',
    requiresFilterValue: true,
  },
  IS_NOT: {
    pattern: 'is_not',
    requiresFilterValue: true,
  },
  IS_CHECKED: {
    pattern: 'is_checked',
    requiresFilterValue: false,
  },
  IS_NOT_CHECKED: {
    pattern: 'is_not_checked',
    requiresFilterValue: false,
  },
  IS_EMPTY: {
    pattern: 'is_empty',
    requiresFilterValue: false,
  },
  IS_NOT_EMPTY: {
    pattern: 'is_not_empty',
    requiresFilterValue: false,
  },
  FILENAMES_CONTAIN: {
    pattern: 'filenames_contain',
    requiresFilterValue: true,
  },
  HAS_FILE_TYPE: {
    pattern: 'has_file_type',
    requiresFilterValue: false,
    subpatters: HAS_FILE_TYPE_SUBPATTERNS,
  },
  HAS_ANY_OF: { pattern: 'has_any_of', requiresFilterValue: true },
  HAS_ALL_OF: { pattern: 'has_all_of', requiresFilterValue: true },
  IS_EXACTLY: { pattern: 'is_exactly', requiresFilterValue: true },
  HAS_NONE_OF: { pattern: 'has_none_of', requiresFilterValue: true },
  IS_ANY_OF: { pattern: 'is_any_of', requiresFilterValue: true },
  IS_NONE_OF: { pattern: 'is_none_of', requiresFilterValue: true },
  IS_LESS_THAN: { pattern: 'is_less_than', requiresFilterValue: true },
  IS_GREATER_THAN: { pattern: 'is_greater_than', requiresFilterValue: true },
  IS_LESS_THAN_OR_EQUAL_TO: {
    pattern: 'is_less_than_or_equal_to',
    requiresFilterValue: true,
  },
  IS_GREATER_THAN_OR_EQUAL_TO: {
    pattern: 'is_greater_than_or_equal_to',
    requiresFilterValue: true,
  },
  IS_WITHIN: {
    pattern: 'is_within',
    requiresFilterValue: true,
    subpatters: IS_WITHIN_SUBPATTERNS,
  },
  IS_BEFORE: {
    pattern: 'is_before',
    requiresFilterValue: true,
    subpatters: DATE_SUBPATTERNS,
  },
  IS_AFTER: {
    pattern: 'is_after',
    requiresFilterValue: true,
    subpatters: DATE_SUBPATTERNS,
  },
  IS_ON_OR_BEFORE: {
    pattern: 'is_on_or_before',
    requiresFilterValue: true,
    subpatters: DATE_SUBPATTERNS,
  },
  IS_ON_OR_AFTER: {
    pattern: 'is_on_or_after',
    requiresFilterValue: true,
    subpatters: DATE_SUBPATTERNS,
  },
};
